module.exports = __webpack_public_path__ + "static/media/HighPower.a344d14c.svg";